import React, { useState } from 'react'
import { Card, Form, Button } from 'react-bootstrap'
import { createUserWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth'
import { auth } from '../../firebase-config'

export default function Register() {

    const [user, setUser] = useState();
    const [registerUser, setRegisterUser] = useState({
        email: "",
        password: "",
    });

    const setUserData = (event) => {
        const { name, value } = event.target;
        // console.log(name, ' => ', value);
        setRegisterUser({ ...registerUser, [name]: value })
    }

    onAuthStateChanged(auth, (currentUser) => {
        setUser(currentUser)
    })

    const register = async (e) => {
        e.preventDefault();
        try {
            const { email, password } = registerUser
            const user = await createUserWithEmailAndPassword(auth, email, password)
            console.log(user)
            setRegisterUser({email:"", password:""})
        } catch (error) {
            console.log(error.message)
        }
    }

  return (
    <div className='container'>
        <div className='row pt-3'>
            <div className='col-md-4 offset-4'>
            {user?.email &&
                <Card>
                    <Card.Body>Ooops!! Not Allowed!!</Card.Body>
                </Card>
            }
            {!user?.email &&
                <Card>
                    <Card.Body>
                        <h3>Register New User</h3>
                        <hr/>
                        <>
                            <Form.Floating className="mb-3">
                                <Form.Control
                                    id="floatingInputCustom"
                                    type="email"
                                    name="email"
                                    placeholder="name@example.com"
                                    value={registerUser.email}
                                    onChange={setUserData}
                                />
                                <label htmlFor="floatingInputCustom">Email address</label>
                            </Form.Floating>
                            <Form.Floating>
                                <Form.Control
                                    id="floatingPasswordCustom"
                                    type="password"
                                    placeholder="Password"
                                    value={registerUser.password}
                                    onChange={setUserData}
                                    name="password"
                                />
                                <label htmlFor="floatingPasswordCustom">Password</label>
                            </Form.Floating>
                            <div className="d-grid gap-2 mt-2">
                                <Button variant="primary" size="lg" type="submit" onClick={register}>
                                   Register User
                                </Button>
                            </div>
                        </>
                    </Card.Body>
                </Card>
            }
            </div>
        </div>
    </div>
  )
}
